<template>
  <div>
    <div class="result" v-if="value.file">
      <div>
        <a :href="getFileLink(value.file.link)">{{ value.file.name }}</a>
        <v-btn
          class="ml-3"
          depressed
          color="transparent"
          x-small
          fab
          :loading="loading"
          @click="remove"
          :disabled="disabledRemove"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <div>
        <a :href="getFileLink(value.fileSig.link)">{{ value.fileSig.name }}</a>
        <v-btn
          class="ml-3"
          depressed
          color="transparent"
          x-small
          fab
          :loading="loading"
          @click="remove"
          :disabled="disabledRemove"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </div>
    <div class="pb-4" v-else>
      <div class="d-flex">
        <UploadDocument
          :has-description="hasDescription"
          :accept-sign="acceptSign"
          :accept-file="acceptFile"
          :disabled-sign="disabledSign"
          :disabled-sig-name-validation="disabledSigNameValidation"
          @change="$emit('change', $event)"
          :document-types="documentTypes"
          :with-select="withSelect"
					:hint="hint"
        />
        <LoadDocumentProfile
          v-if="loadProfileDocumentType"
          :multiple="false"
          :document-type="loadProfileDocumentType"
          @change="$emit('change-from-profile', $event)"
          class="ml-5"
        />
      </div>

      <div class="uds-error">
        <div v-for="(error, index) in errorMessages" :key="index">
          {{ error }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mdiTrashCanOutline } from '@mdi/js';

import { getValidationErrorText } from '@/utils/validate';
import { deleteFile, getFileLink } from '@/api/filestorage';
import { ErrorAlertModule } from '@/store/modules/errors';
import UploadDocument from './UploadDocument';
import LoadDocumentProfile from './LoadDocumentProfile';
import { errorHandler } from '@/utils/common';

const InputType = {
  FILE: 'file',
  FILE_SIG: 'fileSig',
};

export default {
  name: 'AttachDocumentSingle',
  props: {
    value: {
      type: Object,
      required: true,
    },
    errorMessages: {
      type: Array,
    },
    acceptFile: {
      type: Array,
    },
    acceptSign: {
      type: Array,
    },
    loadProfileDocumentType: {
      type: String,
    },
    disabledRemove: {
      type: Boolean,
    },
    disabledSign: {
      type: Boolean,
    },
    disabledSigNameValidation: {
      type: Boolean,
    },
    documentTypes: {
      type: Array,
      required: false
    },
    withSelect: {
      type: Boolean,
      default: false
    },
    hasDescription: {
      type: Boolean,
      default: false
    },
		hint: {
			type: Boolean,
			default: true,
		}
  },
  components: {
    UploadDocument,
    LoadDocumentProfile,
  },
  data: () => ({
    InputType,
    mdiTrashCanOutline,
    getValidationErrorText,
    getFileLink,
    dialog: false,
    attachedFile: null,
    attachedFileSig: null,
    isSigningPlugin: false,
    loading: false,
    loadingSign: false,
  }),
  methods: {
    async remove() {
      this.loading = true;
      ErrorAlertModule.setErrorAlert('');

      try {
        await deleteFile(this.value.file.link);

        this.$emit('change', { file: null, fileSig: null });
      } catch (error) {
        errorHandler(error);
      }

      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.result {
  padding-bottom: 22px;
}

.uds-error {
  min-height: 20px;
  padding-top: 8px;

  div {
    font-size: 12px;
    line-height: 1;
    color: $color-error;
  }
}
</style>
